import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";

import AnalysisForm from "../components/AnalysisForm";
import AnalysisChart from "../components/AnalysisChart";

import { getHomePageData, categoryCost, departmentCost, peopleCost } from "../services/api";


function HomePage() {

    // FORM state
    const [categoria, setCategoria] = useState("");
    const [commessa, setCommessa] = useState("");
    const [reparto, setReparto] = useState("");
    const [tipologiaVista, setTipologiaVista] = useState("");

    // OPTIONS da backend
    const [categorieOptions, setCategorieOptions] = useState([]);
    const [commesseOptions, setCommesseOptions] = useState([]);
    const [repartiOptions, setRepartiOptions] = useState([]);

    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(false);

    // risultati analisi
    const [results, setResults] = useState(null);

    // riepilogo dati inseriti
    const [submittedData, setSubmittedData] = useState(null);

    // ----- LOAD INIZIALE -----
    useEffect(() => {
        async function loadData() {
            try {
                setLoading(true);
                const data = await getHomePageData();
                setCategorieOptions(data.categorie);
                setCommesseOptions(data.commesse);
                setRepartiOptions(data.reparti);
            } catch (err) {
                alert("Errore caricamento dati form: " + err.message);
            } finally {
                setLoading(false);
            }
        }
        loadData();
    }, []);

    // ----- SELEZIONE API -----
    function selectAPI({ categoria, commessa, reparto, tipologiaVista }) {

        if (categoria === "all" && tipologiaVista === "categoria") {
            return categoryCost;
        }

        if (categoria !== "all" && tipologiaVista === "reparto") {
            return departmentCost;
        }

        if (categoria !== "all" && tipologiaVista === "persone") {
            return peopleCost;
        }

        return null;
    }

    // ----- SUBMIT -----
    const handleSubmit = async (e) => {
        e.preventDefault();
        setResults(null);
        setProcessing(true);

        const formData = { categoria, commessa, reparto, tipologiaVista };

        try {
            const selectedFunction = selectAPI(formData);

            if (!selectedFunction) {
                throw new Error(
                    `Combinazione non valida: Categoria=${categoria}, Commessa=${commessa}, Reparto=${reparto}, TipologiaVista=${tipologiaVista}`
                );
            }

            const data = await selectedFunction(formData);

            setResults(data);
            setSubmittedData(formData);

            // reset form
            // setCategoria("");
            // setCommessa("");
            // setReparto("");
            // setTipologiaVista("");

        } catch (err) {
            alert(err.message);
        } finally {
            setProcessing(false);
        }
    };

    // ----- LOADING -----
    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Caricamento dati...</p>
            </Container>
        );
    }

    console.log("RESULTS API:", results);

    return (
        <Container className="mt-5">
            <Row className="g-4">

                {/* SIDEBAR */}
                <Col md={3}>
                    <AnalysisForm
                        categoria={categoria}
                        commessa={commessa}
                        reparto={reparto}
                        tipologiaVista={tipologiaVista}
                        setCategoria={setCategoria}
                        setCommessa={setCommessa}
                        setReparto={setReparto}
                        setTipologiaVista={setTipologiaVista}
                        categorieOptions={categorieOptions}
                        commesseOptions={commesseOptions}
                        repartiOptions={repartiOptions}
                        onSubmit={handleSubmit}
                        disabled={processing}
                    />

                    {processing && (
                        <div className="text-center mt-3">
                            <Spinner animation="border" size="sm" />
                            <span> Elaborazione in corso...</span>
                        </div>
                    )}

                    {submittedData && !processing && (
                        <Card className="mt-3 shadow-sm border-0 p-3">
                            <h6>Riepilogo dati inseriti:</h6>
                            <p style={{ fontStyle: "italic" }}>
                                <strong>Categoria:</strong> {submittedData.categoria}<br/>
                                {submittedData.categoria !== "all" && (
                                    <>
                                        <strong>Commessa:</strong> {submittedData.commessa}<br/>
                                    </>
                                )}
                                <strong>Reparto:</strong> {submittedData.reparto}<br/>
                                <strong>Tipologia Vista:</strong> {submittedData.tipologiaVista}
                            </p>
                        </Card>
                    )}
                </Col>

                {/* MAIN */}
                <Col md={9}>
                    <Card className="shadow-sm border-0 p-3">

                        {submittedData && results ? (
                            <AnalysisChart
                                budget={results.budget}
                                actualCost={results.actual_cost}
                                forecast={results.forecast}
                                months_present={results.months_present}
                                months_future={results.months_future}
                                chartType={results.chartType}
                            />
                        ) : (
                            <div className="text-center text-muted py-5">
                                <h5>Compila il form per avviare un’analisi</h5>
                            </div>
                        )}

                    </Card>
                </Col>

            </Row>
        </Container>
    );
}

export default HomePage;